module.exports = __webpack_public_path__ + "static/media/21ECLAC30.42222e80.jpg";